import { render } from "./GenericTable.vue?vue&type=template&id=6feec9ba&ts=true"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"

import "./GenericTable.vue?vue&type=style&index=0&id=6feec9ba&lang=css"

import exportComponent from "/var/www/mitliv/wp-content/themes/wp-mitliv-theme/resources/views/backend/statistics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__